// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarProfesorAsistencias_main__ZXGhk","intro":"ModalEditarProfesorAsistencias_intro__gXZv5","input":"ModalEditarProfesorAsistencias_input__1fuw+"};